<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon mastodon-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 232.01 232.01"
			version="1.1"
			viewBox="0 0 232.01 232.01"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<path d="m115.77 0.52697c-29.661 0.2425-58.193 3.4544-74.821 11.091 0 0-32.977 14.751-32.977 65.081 0 11.525-0.22401 25.305 0.14099 39.919 1.1975 49.22 9.0231 97.729 54.531 109.77 20.982 5.5538 38.998 6.7173 53.507 5.9198 26.311-1.4588 41.082-9.3897 41.082-9.3897l-0.86792-19.091s-18.803 5.9282-39.919 5.2057c-20.921-0.71751-43.008-2.2556-46.392-27.942-0.3125-2.2562-0.46875-4.6696-0.46875-7.2034 0-1e-5 20.538 5.0203 46.566 6.2128 15.915 0.73 30.839-0.93234 45.998-2.7411 29.07-3.4712 54.382-21.383 57.563-37.749 5.0125-25.781 4.5996-62.915 4.5996-62.915 0-50.33-32.975-65.081-32.975-65.081-16.626-7.6362-45.176-10.848-74.837-11.091zm-33.569 39.326c12.355 0 21.71 4.7487 27.896 14.247l6.015 10.082 6.015-10.082c6.185-9.4988 15.54-14.247 27.896-14.247 10.678 0 19.281 3.7535 25.851 11.076 6.3688 7.3225 9.5398 17.221 9.5398 29.676v60.941h-24.144v-59.15c0-12.469-5.246-18.798-15.74-18.798-11.602 0-17.417 7.5067-17.417 22.352v32.377h-24.001v-32.377c0-14.845-5.8163-22.352-17.419-22.352-10.494 0-15.74 6.3289-15.74 18.798v59.15h-24.144v-60.941c0-12.455 3.1716-22.353 9.5416-29.676 6.5688-7.3225 15.172-11.076 25.851-11.076z" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'MastodonIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
}
</script>
